export default function AdminContentText({ value, fallback = "Not provided" }) {
  return (
    <span className="mx-auto block w-40 truncate sm:w-56" title={value || fallback}>
      {value || fallback}
    </span>
  );
}
